// react imports
import React from "react"

// package imports
import { observer } from "mobx-react"

// project imports
import { BottomsheetDropdown } from "components";

const SaralPension = ({ form, data }) => {

  return (
    <div className="">
      {/* //! no pt in product */}
      <div className="mx-0 my-4">
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey='label'
          menuList={[]}
          value={{ "id": "", "label": "" }}
          disabled={true}
        />
      </div>
      {/* //! no ppt in product */}
      <div className="mx-0 my-4">
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey='label'
          menuList={[]}
          value={{ "id": "", "label": "" }}
          disabled={true}
        />
      </div>
    </div>
  )
}

export default observer(SaralPension)
